import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader } from "../../MenuCard";

const ITEMS = [
  { label: "Ventas",      icon: "fas fa-chart-line",    color: "#10b981", bg: "#f0fdf4", href: "/MenuReportesVentas", desc: "Reportes de ventas",      perm: "menu_reportes" },
  { label: "Admin",       icon: "fas fa-chart-bar",     color: "#3b82f6", bg: "#eff6ff", href: "/MenuReportesAdmin",  desc: "Reportes administrativos", perm: "menu_reportes" },
  { label: "Dashboards",  icon: "fas fa-tachometer-alt",color: "#8b5cf6", bg: "#f5f3ff", href: "/Dashboards",         desc: "Tableros de control",     perm: "menu_reportes" },
];

function BotonesReportes() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-chart-bar" color="#3b82f6" bg="#eff6ff" title="Reportes" subtitle="Análisis y tableros de control" />
        {user.menu_reportes ? (
          <div className="row">
            {ITEMS.map((r, i) => <MenuCard key={i} {...r} enabled={!!user[r.perm]} />)}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesReportes;
